<!--主页-->
<template>
  <el-container class="home-container">
    <!--头部区域-->
    <el-header>
      <div>
        <span>河蟹后台商户系统</span>
      </div>
      <div class="time">{{time}}</div>

      <el-dropdown trigger="click" size="small">
      <span class="el-dropdown-link">
        <el-avatar class="avatar" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
      </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-container>
      <!--左侧区域-->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <el-menu background-color="#333744" text-color="#fff" active-text-color="#409eff" unique-opened
                 :collapse="isCollapse" :collapse-transition="false" router
        :default-active="activePath">
          <!--左侧菜单栏循环渲染-->
          <el-menu-item :index="'/'+ 'Welcome'">
            <i class="el-icon-s-home"></i>
            <span slot="title">数据看板</span>
          </el-menu-item>
          <el-submenu :index="item.id + ''" v-for="item in menu" :key="item.id">
            <template slot="title">
              <i :class="icons[item.id]"></i>
              <span>{{item.name}}</span>
            </template>
            <el-menu-item :index="'/'+sub.path" v-for="sub in item.children"
                          :key="sub.id" @click="saveNavState('/'+sub.path)">
              <i :class="iconsChild[sub.id]"></i>
              <span>{{sub.name}}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!--右侧区域-->
      <el-main>
        <!--Welcome组件路由出口-->
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import menuList from '../assets/json/home'
import request from '../http/auth'
export default {
  name: 'Home',
  created () {
    /* 当Home组件被创建时,激活左侧导航栏选中部分高亮 */
    this.activePath = window.sessionStorage.getItem('activePath')
    /* 获取当前系统时间,当组件被加载时 */
    setInterval(() => {
      this.formatTime()
    }, 1000)
  },
  data () {
    return {
      /* 菜单栏是否展开 */
      isCollapse: false,
      /* 存放左侧菜单栏渲染数据 */
      menu: menuList.data,
      /* 被激活的链接地址 */
      activePath: '',
      /* 存放当前时间 */
      time: '',
      /* 存放一级菜单栏渲染图标 */
      icons: {
        '001': 'el-icon-s-shop',
        '002': 'el-icon-s-order'

      },
      /* 存放二级菜单栏渲染图标 */
      iconsChild: {
        '0001': 'el-icon-menu',
        '0002': 'el-icon-s-fold'
      }
    }
  },
  methods: {
    async logout () {
      /* 清除session缓存并跳转到登录页面 */
      const res = await request.logout()
      console.log(res)
      if (res.data.message === 'SUCCESS') {
        window.sessionStorage.clear()// 清空缓存
        // 刷新当前页面,回到登录状态
        this.$router.push('/Login')
        location.reload()
      }
    },
    /* 点击按钮,切换菜单的折叠与展开 */
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    // 保存链接激活状态
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    },
    formatTime () {
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = function (fmt) {
        const o = {
          'M+': this.getMonth() + 1, // 月份
          'd+': this.getDate(), // 日
          'h+': this.getHours(), // 小时
          'm+': this.getMinutes(), // 分
          's+': this.getSeconds(), // 秒
          'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
          S: this.getMilliseconds() // 毫秒
        }
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
        for (const k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
        return fmt
      }
      this.time = (new Date()).format('yyyy年MM月dd日 hh:mm:ss')
      //  console.log(this.time);
    }
  }
}
</script>

<style lang="less" scoped>
  .home-container{
    height: 100%;
  }
.el-header{
  background-color: #333744;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: white;
  font-size: 15px;
  .avatar{
     position: absolute;
     right: 10px;
    bottom: -18px;
  }
  > div{
    display: flex;
    align-items: center;
    span{
      margin-left: 15px;
    }
  }
}
  .el-aside{
    background-color: #333744;
    .el-menu{
      border-right: none;
    }
  }
  .el-main{
    background-color: #eee;
  }
  .toggle-button{
    background-color: #4a5064;
    font-size: 10px;
    line-height: 24px;
    color: white;
    text-align: center;
    letter-spacing: 0.2em;
    cursor: pointer;
  }
  .time{
    position: absolute;
    right: 88px;
  }
  .el-dropdown-link {
    cursor: pointer;
  }
  .el-popper[x-placement^=bottom] {
    margin-top: 22px;
    margin-right: 7px;
  }

</style>
